//basic
import React from 'react';
import { toJS } from 'mobx'


//style
import './ChangeSiblingsPositions.scss';


//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

//custom components
import CustomButton from '../../../components/basic/CustomButton';

//other
import {SortableContainer, SortableElement, arrayMove, SortableHandle} from 'react-sortable-hoc';
import Icon from '@mdi/react';
import {mdiMenu} from '@mdi/js';
import { inject, observer } from 'mobx-react';
import {api} from '../../../functions/api';

@inject('internal')
@inject('translate')
@observer
export default class ChangeSiblingsPositions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingBtn: false,
            items: [],
        }
    }
    
    componentWillReceiveProps() {
        this.timeout = setTimeout(() => {
                let items = toJS(this.props.childs)
                this.setState({items: items})
        }, 10)
       
    }
    

    componentWillUnmount() {
        clearTimeout( this.timeout)
    }
    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
            items: arrayMove(this.state.items, oldIndex, newIndex),
        });
        
    };

    updateCategoriesPositions = async() => {
        
        this.setState({loadingBtn: true})

        let newIds = []
        for(let i=0 ; i<this.state.items.length; i++) {
            newIds.push(this.state.items[i].id)
        }

        let update_data = await api({
            method: 'patch',
            url: 'lists/banners/position',
            authorization: this.props.internal.user.access_token,
            params: {
                ids: newIds
            }
        })

        if(update_data.success === true) {
            // this.props.showSnackbar(update_data.data.message, true)
            this.props.internal.setSnackbar("Zmeny boly uložené", true)
            this.props.onClose();
            this.props.internal.resetParents()
        }
        else {
            this.props.showSnackbar(update_data.data.message, true)
        }
        this.setState({loadingBtn: false})

    }


    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title" className={'text-center'}>{this.props.title}</DialogTitle>
                <DialogContent className={'flex drowable-list'}>
                    <SortableList items={this.state.items} onSortEnd={this.onSortEnd} useDragHandle={true} helperClass={'drag-and-drop'}/>
                </DialogContent>
                <DialogActions className={'drag-and-drop-btns'}>
                    <Button
                        onClick={this.props.onClose}
                        className={'gray-text'}
                    >
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.updateCategoriesPositions}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                    />
                </DialogActions>
            </Dialog>
        );
    }
}

const SortableItem = SortableElement(({value}) =>
    <li className={'flex space-between'}>
        <span >{value}</span>
        {/* <IconButton aria-label="Menu" className={'burger-menu-btn'} >
            <MenuIcon />
        </IconButton>   */}
        <DragHandle/>
    </li>
);

const SortableList = SortableContainer(({items}) => {
    return (
        <ul className={'drowable-list '}>
            {items.map((value, index) => (
                <SortableItem key={`item-${index}`} index={index} value={value.title} />
            ))}
        </ul>
    );
});

// const DragHandle = SortableHandle(() => <span>::</span>);
const DragHandle = SortableHandle(() =>
    <Icon path={mdiMenu} size = {1 } className={'move-btn'}  />
);



// WEBPACK FOOTER //
// ./src/screens/banner/ChangeSiblingsPositions/ChangeSiblingsPositions.jsx